import { getCurrentUserEmail } from "Services";
import { RootState } from "Store/store";
import { CurrentUserUpdatesMessage } from "Types";
import { GetUsersListRequest, GetUsersListResponse } from "../types";

export const updateUsersListCache = (
  arg: GetUsersListRequest,
  draft: GetUsersListResponse,
  message: CurrentUserUpdatesMessage,
  state: RootState,
): GetUsersListResponse => {
  const currentUserEmail = getCurrentUserEmail(state);

  if (message.initiated_by === currentUserEmail) return draft;

  const currentGroup = message.data.org_groups.find(
    (group) => group.group_id === arg.group,
  );

  return {
    match_count: draft.match_count,
    users: draft.users.map((item) => {
      if (item.user_id === message.data.user_id) {
        return {
          ...message.data,
          org_groups: item.org_groups.map((group) => {
            if (group.group_id === currentGroup?.group_id && currentGroup?.role)
              return { ...group, role: currentGroup.role };
            else return group;
          }),
        };
      } else {
        return item;
      }
    }),
  };
};
